// One-time delegation codes. 10 characters of Crockford base32 = 50 bits: guessing one at a
// kiosk is not a realistic attack, and the kiosk rate-limits entry anyway.
import { canonicalHash } from "./canonical.ts";

const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

export function newDelegationCode(): string {
  const b = crypto.getRandomValues(new Uint8Array(10));
  let s = "";
  for (const x of b) s += ALPHABET[x & 31];
  return `${s.slice(0, 5)}-${s.slice(5)}`;
}

/** Accepts what people type: lower case, spaces, and the usual O/0 I/1 L/1 confusions. */
export function normaliseCode(input: string): string {
  const s = input.toUpperCase().replace(/[\s-]/g, "").replace(/O/g, "0").replace(/[IL]/g, "1").replace(/U/g, "V");
  return s.length === 10 ? `${s.slice(0, 5)}-${s.slice(5)}` : s;
}

export const codeHash = (delegationId: string, code: string) =>
  canonicalHash({ delegation_id: delegationId, code: normaliseCode(code) });
